export default { options: { label: 'Sponsors app oficial section' } }
